import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Importing the customParseFormat plugin to enable parsing of custom date formats
// This is necessary for the isValidDateFormat function to work correctly
dayjs.extend(customParseFormat);

export const isRequiredValid = (
  value: string | boolean | number | null | undefined
) => {
  return !(value == null || (typeof value === "string" && value.trim() === ""));
};

export const isValidEmail = (email: string) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const isValidDateFormat = (
  date: string,
  format: dayjs.OptionType = "L"
): boolean => {
  let isValid = false;

  const resolvedFormat =
    format === "L" ? dayjs.localeData().longDateFormat("L") : format;

  const parsed = dayjs(date, resolvedFormat, true);

  if (parsed.isValid()) {
    const year = parsed.year();
    const minYear = 1900;
    const today = dayjs();
    const inputDate = dayjs(date, resolvedFormat);

    isValid = year >= minYear && inputDate.isBefore(today);
  }
  return isValid;
};
